import { isEmpty } from 'lodash';

import { CALL_API } from '../../middlewares/api';
import { REQUEST_PARTNER_SHOPS, RECEIVE_PARTNER_SHOPS, FAILURE_PARTNER_SHOPS } from './constants';

const shouldFetchShops = (state, idPartner) => {
    if (!idPartner) {
        return;
    }
    const shops = state.shop.shops[idPartner] ? state.shop.shops[idPartner] : [];
    const fetching = state.shop.fetching;
    return fetching ? false : isEmpty(shops);
};

export const fetchPartnerShopsIfNeeded = id => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}/store`,
            types: [REQUEST_PARTNER_SHOPS, RECEIVE_PARTNER_SHOPS, FAILURE_PARTNER_SHOPS],
            shouldCallAPI: state => shouldFetchShops(state, id),
            payload: { id }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/shop/actions.js